import React, { useEffect, useState } from 'react';
import { RequestMethod, useApi } from '../hooks/useApis';
// import Description from '../components/Description';
import '../styles/MainPage.css';

const MainPage = () => {
  const [roomId, setRoomId] = useState('');
  const { data, fetchData } = useApi({
    endpoint: '/rooms/create',
    method: RequestMethod.POST,
    body: null
  });

  const handleMakeRoom = async () => {
    await fetchData();
  };

  useEffect(() => {
    if (data) {
      const id = data.id;
      window.location.href = `/rooms/${id}`;
    }
  }, [data]);

  const handleGoingToRoom = () => {
    if (roomId.length < 6) {
      alert('방 ID를 6자리로 입력해주세요.');
      return;
    }
    window.location.href = `/rooms/${roomId}`;
  };

  const maxLengthCheck = (object: any) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleGoingToRoom();
  };

  return (
    <>
      {/* <Description /> */}
      <form onSubmit={onSubmit}>
        <input
          type="text"
          placeholder="방 ID를 입력해주세요"
          maxLength={6}
          onInput={maxLengthCheck}
          value={roomId || ''}
          onChange={(event) => setRoomId(event.target.value)}
        />
      </form>
      <div style={{ height: '40px' }}></div>
      <button onClick={handleGoingToRoom}>Go to Room</button>
      <button onClick={handleMakeRoom}>Create Room</button>
    </>
  );
};

export default MainPage;
